module.exports = __webpack_public_path__ + "img/map_time.c5b1cab5.png";